import { createAction } from 'redux-act';

export const setInternalValue = createAction('Set internal value');
export const setBrandingColors = createAction('Set branding colors');
export const setCustomProfileFields = createAction('Set custom profile fields');
